import { render, staticRenderFns } from "./MarineComponent.vue?vue&type=template&id=236c35b9&"
import script from "./MarineComponent.vue?vue&type=script&lang=js&"
export * from "./MarineComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports